enum FileUploaderStatus {
  ABORTED = 'aborted',
  DONE = 'done',
  ERROR = 'error',
  LOAD = 'load',
  PENDING = 'pending',
}

export default FileUploaderStatus;
